import gsap from 'gsap';

const getCssVar = (name) => {
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
};

export const createReactivateStartScreenTimeline = (
  { header, headerH1, headerH1Small, headerP, svgBg },
  { onComplete } = {}
) => {
  const tl = gsap.timeline({ paused: true, onComplete });

  const headerTextColor = `rgba(${getCssVar('--color-header-text')}, 1)`;
  const primaryBgTransparent = `rgba(${getCssVar('--color-primary-800')}, 0)`;

  tl.to(header, {
    duration: 1,
    color: headerTextColor,
    autoAlpha: 1,
    x: '1.75rem',
    y: '1.75rem',
    padding: 0,
    borderRadius: 4,
    backgroundColor: primaryBgTransparent,
    ease: 'power4.out'
  }, 0);

  tl.to(headerH1, {
    duration: 1,
    color: headerTextColor,
    fontSize: '1.875rem',
    lineHeight: '1.25rem',
    ease: 'power4.out'
  }, 0);

  tl.to(headerH1Small, {
    duration: 1,
    color: headerTextColor,
    maxWidth: '4rem',
    marginLeft: '0.75rem',
    ease: 'power4.out'
  }, 0);

  tl.to(headerP, {
    duration: 0.75,
    color: headerTextColor,
    autoAlpha: 1,
    height: '1rem',
    width: 'auto',
    ease: 'power4.out'
  }, 0);

  tl.to(svgBg, {
    duration: 0.75,
    y: '-80vh',
    ease: 'elastic.out(1, 0.65)'
  }, 0.25);

  return tl;
};

export const createStartScreenIntroTimeline = (
  { header, svgBg },
  { onStart } = {}
) => {
  // Start with transparent background - on the start screen, the logo should not have a background
  gsap.set(header, { x: 8, y: 16, autoAlpha: 0, backgroundColor: 'transparent' });
  gsap.set(svgBg, { transformOrigin: 'center', y: 0 });

  const tl = gsap.timeline({ paused: true, onStart });
  tl.to(header, { duration: 1, autoAlpha: 1, x: 16, y: 16, backgroundColor: 'transparent', ease: 'elastic' }, 0)
    .to(svgBg, { duration: 1, y: '-80vh', ease: 'elastic.out(1, 0.65)' }, 0.3);

  return tl;
};

export const createDeactivateStartScreenTimeline = (
  { header, headerH1, headerH1Small, headerP, svgBg },
  { onStart } = {}
) => {
  const tl = gsap.timeline({ paused: true, onStart });

  // Use hardcoded colors for logo - should always be dark magenta bg with light text
  // regardless of dark mode settings (CSS variables change with theme)
  const primaryBgSolid = 'rgb(157, 23, 77)';     // pink-800 - dark magenta
  const primaryTextColor = 'rgb(252, 231, 243)'; // pink-100 - light pink/white

  tl.to(header, {
    duration: 1,
    autoAlpha: 1,
    x: 1,
    y: 1,
    padding: '0.375rem 0.5rem 0.25rem 0.5rem',
    borderRadius: 4,
    backgroundColor: primaryBgSolid,
    ease: 'power4.out',
    // After animation completes, clear inline backgroundColor so CSS hover can work
    onComplete: () => {
      header.style.backgroundColor = '';
    }
  }, 0);

  tl.to(headerH1, {
    duration: 1,
    fontSize: 18,
    lineHeight: 1,
    color: primaryTextColor,
    ease: 'power4.out'
  }, 0);

  tl.to(headerH1Small, {
    duration: 1,
    maxWidth: 0,
    marginLeft: 0,
    ease: 'power4.out'
  }, 0);

  tl.to(headerP, {
    duration: 1,
    autoAlpha: 0,
    height: 0,
    width: '4rem',
    ease: 'power4.out'
  }, 0);

  tl.to(svgBg, {
    duration: 0.75,
    y: '0',
    ease: 'power4.in'
  }, 0.25);

  return tl;
};

